import type { Alpine as AlpineType } from 'alpinejs'
import focus from '@alpinejs/focus'
import collapse from '@alpinejs/collapse'
import persist from '@alpinejs/persist'

import { saveButton } from '@/utils/Alpine/save-button'
import { hybridImageBinding } from '@/utils/Alpine/hybrid-image'
import { alpineVideo } from '@/utils/Alpine/alpine-video'
import { isImageSrc, isVideoSrc } from '@/utils/media-transformer'
import { cardYacht } from '@/utils/Alpine/card-yacht'
import { yachtCarousel } from './components/Cards/card-carousel'
import { cursorWrapper } from '@/utils/Alpine/cursor-wrapper'
import { uiButton } from '@/utils/Alpine/ui-button'
import { interactiveMap } from '@/components/Blocks/Map/scripts/interactive-map-block'
import { map } from './components/Blocks/Map/scripts/map-block'
import { authStore } from '@/stores/auth'
import { moodboardStore } from '@/stores/moodboard'

export interface AlpineExtended extends AlpineType {
  $focus: typeof import('@alpinejs/focus')
  $collapse: typeof import('@alpinejs/collapse')
  $persist: typeof import('@alpinejs/persist')
}

export default (Alpine: AlpineType) => {
  Alpine.plugin(focus)
  Alpine.plugin(collapse)
  Alpine.plugin(persist)
  Alpine.store('auth', authStore(Alpine as AlpineExtended))
  Alpine.store('moodboard', moodboardStore(Alpine as AlpineExtended))
  saveButton(Alpine as AlpineExtended)
  Alpine.data('cursorWrapper', cursorWrapper)
  Alpine.data('button', uiButton)
  Alpine.bind('HybridImage', hybridImageBinding)
  Alpine.bind('AlpineVideo', alpineVideo)
  Alpine.data('backgroundMedia', () => ({
    isImageSrc,
    isVideoSrc,
  }))
  Alpine.data('CardYacht', cardYacht)
  Alpine.data('yachtCarouselDynamic', yachtCarousel)
  Alpine.data('interactiveMap', interactiveMap)
  Alpine.data('map', map)
}
